// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "计算机组成原理",
      "tec": "王健",
      "week": "6-17周",
      "add": "实训楼F座401信息"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "张慧",
      "week": "6-17周",
      "add": "实训楼F座301信息"
    },
    {
      "sub": "就业创业指导",
      "tec": "金霞",
      "week": "6-10周",
      "add": "教学楼C座306教务"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "高等数学基础（一）",
      "tec": "王壮志",
      "week": "6-17周",
      "add": "实训楼F座103自控"
    },
    {
      "sub": "基础英语（一）",
      "tec": "薛旸",
      "week": "6-17周",
      "add": "实训楼F座302信息"
    },
    {
      "sub": "高级语言程序设计",
      "tec": "崔妍",
      "week": "6-17周",
      "add": "实训楼F座401信息"
    },
    [
      {
        "sub": "形势与政策",
        "tec": "祝嘉悦",
        "week": "6-9周",
        "add": "教学楼C座309教务"
      },
      {
        "sub": "军事理论",
        "tec": "田凤权",
        "week": "10-17周",
        "add": "教学楼C座113教务"
      }
    ],
    0
  ],
  "3": [
    {
      "sub": "数据结构与算法",
      "tec": "吕海华",
      "week": "6-17周",
      "add": "实训楼F座402信息"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "张慧",
      "week": "6-17周",
      "add": "教学楼A座127信息"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "基础英语（一）",
      "tec": "薛旸",
      "week": "7,9,11,13,15,17周",
      "add": "实训楼F座302信息"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "王壮志",
      "week": "6-17双周",
      "add": "实训楼F座103自控"
    },
    {
      "sub": "高级语言程序设计",
      "tec": "崔妍",
      "week": "6-17周",
      "add": "实训楼F座401信息"
    },
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "数据结构与算法",
      "tec": "吕海华",
      "week": "6-17周",
      "add": "实训楼F座401信息"
    },
    {
      "sub": "计算机组成原理",
      "tec": "王健",
      "week": "6-17周",
      "add": "实训楼F座302信息"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
